const MyOfficeHome = (props) => {
  return <>Home Page - MyOffice</>;
};

export default MyOfficeHome;
